import React, { useState, useCallback } from 'react'
import { useDispatch } from 'react-redux'
import { css } from '@emotion/react'
import Link from 'redux-first-router-link'
import LegacyLink from 'components/LegacyLink'
import { Dropdown, SVGIcon } from 'shared/ui'
import { SETTINGS_WIDGETS_PAGE } from 'subapps/settings/types'
import { doShowChatAvailabilityModal } from 'actions/modals'

const buttonStyle = () => theme => css`
  cursor: pointer;
  color: ${theme.color.monochrome.mediumDark} !important;
`

const options = [
  {
    key: 'availability',
    value: 'availability',
    text: 'Live chat visibility',
  },
  {
    as: LegacyLink,
    key: 'inbox-prefs',
    value: 'inbox-prefs',
    text: 'Inbox preferences',
    path: 'settings/preferences',
  },
  {
    as: Link,
    key: 'widget-overview',
    value: 'widget-overview',
    text: 'Live chat & widget settings',
    to: {
      type: SETTINGS_WIDGETS_PAGE,
    },
  },
]

const Menu = props => {
  const [open, setOpen] = useState(false)
  const dispatch = useDispatch()

  const toggleMenu = useCallback(
    () => {
      setOpen(o => !o)
    },
    [setOpen]
  )

  const handleSelect = useCallback(
    (_, { value }) => {
      setOpen(false)
      if (value === 'availability') {
        dispatch(doShowChatAvailabilityModal())
      }
    },
    [dispatch, setOpen]
  )

  return (
    <React.Fragment>
      <SVGIcon
        name="settings"
        size={16}
        css={buttonStyle}
        onClick={toggleMenu}
        {...props}
      />
      {open && (
        <Dropdown
          open
          options={options}
          icon={null}
          direction="right"
          closeOnChange
          onChange={handleSelect}
        />
      )}
    </React.Fragment>
  )
}

export default Menu
